var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      staticClass: "dex-token",
      attrs: {
        title: _vm.$t("trade.txPairDetail.title"),
        showMask: true,
        closeIcon: true,
        close: _vm.close
      }
    },
    [
      _c("div", { staticClass: "tx-pair-wrapper" }, [
        _c("div", { staticClass: "tx-pair-item" }, [
          _c("div", { staticClass: "item-title" }, [
            _vm._v(_vm._s(_vm.$t("trade.txPairDetail.24h")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-row" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("trade.txPairDetail.openPrice")) + ":")
            ]),
            _vm._v(
              "\n                " +
                _vm._s(_vm.activeTxPair ? _vm.activeTxPair.openPrice : "--") +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "item-row",
              class: {
                up: +_vm.upDown > 0,
                down: +_vm.upDown < 0
              }
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("trade.upDown")) + ":")]),
              _vm._v(
                "\n                " + _vm._s(_vm.percent) + "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "item-row" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("trade.txPairDetail.quantity")) + ":")
            ]),
            _vm._v(
              "\n                " + _vm._s(_vm.quantity24h) + "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-row" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("trade.txPairDetail.amount")) + ":")
            ]),
            _vm._v(
              "\n                " + _vm._s(_vm.amount24h) + "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tx-pair-item" }, [
          _c("div", { staticClass: "item-title" }, [
            _vm._v(_vm._s(_vm.$t("trade.txPairDetail.status")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-row" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("trade.txPairDetail.latest")) + ":")
            ]),
            _vm._v(
              "\n                " +
                _vm._s(_vm.activeTxPair ? _vm.activeTxPair.closePrice : "--") +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-row" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("trade.txPairDetail.buy")) + ":")
            ]),
            _vm._v(
              "\n                " +
                _vm._s(_vm.buyOne || "--") +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-row" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("trade.txPairDetail.sell")) + ":")
            ]),
            _vm._v(
              "\n                " +
                _vm._s(_vm.sellOne || "--") +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-row" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("trade.txPairDetail.diff")) + ":")
            ]),
            _vm._v(
              "\n                " + _vm._s(_vm.diff || "--") + "\n            "
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }